import { ck, URLS } from "fire-wind-water";
import $ from "jquery";
import webinarService from "../services/webinar";
import URL from "../assets/conf/setting.json";
export default {
  weChatLoad(weChatId, isSilentAuthorise) {
    let defer = $.Deferred();
    let scope = isSilentAuthorise ? "snsapi_base" : "snsapi_userinfo";
    let code = URLS.getURL("excode");
    let token = ck.cookie("verify_" + weChatId);
    let tokenInfo = ck.cookie("verifyInfo_" + weChatId);
    if (tokenInfo && token) {
      defer.resolve({
        tokenInfo: tokenInfo,
        token: token
      });
    } else if (code) {
      webinarService.getTokenByCode({ code: code }).subscribe(data => {
        if (data.result == "0") {
          token = data.content.token;
          tokenInfo = data.content.tokenInfo;
          ck.cookie("verify_" + weChatId, token, {
            expires: 1 / 12,
            domain: window.$sk.config.domain,
            path: "/"
          });
          ck.cookie("verifyInfo_" + weChatId, tokenInfo, {
            expires: 1 / 12,
            domain: window.$sk.config.domain,
            path: "/"
          });
          defer.resolve({
            tokenInfo: tokenInfo,
            token: token
          });
        } else {
          this.authorization(
            {
              weChatId: weChatId,
              scope: scope
            },
            "auth"
          ).fail(() => {
            defer.reject();
          });
        }
      });
    } else {
      this.authorization(
        {
          weChatId: weChatId,
          scope: scope
        },
        "auth"
      ).fail(() => {
        defer.reject();
      });
    }
    return defer.promise();
  },
  authorization(options, loginUrlKey) {
    let defer = $.Deferred();
    loginUrlKey = loginUrlKey || "login";
    webinarService
      .getOAuth({ weChatId: options["weChatId"] })
      .subscribe(data => {
        if (data.content.canOAuth != 1) {
          defer.reject();
          return;
        }
        var loginUrl = data.content[loginUrlKey];

        loginUrl = URLS.updateParam(
          "return_url",
          encodeURIComponent(window.location.href),
          loginUrl
        );

        if ("scope" in options) {
          loginUrl = URLS.updateParam("scope", options["scope"], loginUrl);
        }

        if ("sess" in options) {
          loginUrl = URLS.updateParam("sess", options["sess"], loginUrl);
        }

        if ("paramName" in options) {
          loginUrl = URLS.updateParam(
            "paramName",
            options["paramName"],
            loginUrl
          );
        }

        window.$sk.goto(loginUrl);
      });
    return defer.promise();
  }
};
